import Vue from 'vue';
import Router from 'vue-router';
import Store from '../store';
import Auth from '../services/Auth';
import Permissions from '../services/Permissions';
import Calls from '@/components/calls/Calls';
import CallsList from '@/components/calls/List';
import NewCall from '@/components/calls/New';
import Call from '@/components/calls/Call';
import Error from '@/components/Error';
import Login from '@/components/Login';

Vue.use(Router);

const ANY_ROLE = '*';

const router = new Router({
	mode: 'history',
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {x: 0, y: 0};
		}
	},
	routes: [
		{
			path: '/',
			redirect: '/calls'
		},
		{
			path: '/calls',
			component: Calls,
			meta: {allowedRoles: [ANY_ROLE]},
			children: [
				{
					path: '',
					component: CallsList,
					beforeEnter: async function (to, from, next) {
						//Store.dispatch('hideContent');
						await Store.dispatch('getCalls');
						await Store.dispatch('getDropdownSchools');
						await Store.dispatch('getDropdownReasons');
						await Store.dispatch('getDropdownCallerTypes');
						next();
						//Store.dispatch('showContent');
					}
				},
				{
					path: 'new',
					component: NewCall,
					beforeEnter: async function (to, from, next) {
						//Store.dispatch('hideContent');
						await Store.dispatch('getDropdownSchools');
						await Store.dispatch('getDropdownReasons');
						await Store.dispatch('getDropdownCallerTypes');
						next();
						//Store.dispatch('showContent');
					}
				},
				{
					path: ':callId',
					component: Call,
					beforeEnter: async function (to, from, next) {
						//Store.dispatch('hideContent');
						await Store.dispatch('getCall', to.params.callId);
						next();
						//Store.dispatch('showContent');
					}
				}
			]
		},
		{
			path: '/login',
			component: Login
		},
		{
			path: '*',
			component: Error
		}
	]
});

router.beforeEach(async function (to, from, next) {

	const canEnter = await checkPermissions(to);

	if (canEnter) {
		console.log('can enter');
		next();
	} else {
		console.log('cannot enter');
		next({
			path: '/login',
			query: {
				redirect: to.fullPath
			}
		});
	}
});

async function checkPermissions (routeToCheck) {

	for (var i = 0; i < routeToCheck.matched.length; i++) {

		const route = routeToCheck.matched[i];

		console.log('checking', route.path);

		if (route.meta && route.meta.allowedRoles) {

			if (!Auth.isAuthenticated()) {
				console.log('user not authenticated');

				try {
					const result = await Auth.authenticate();
					if (!result) return false;
				} catch (error) {
					return false;
				}

			}

			const routeRoles = route.meta.allowedRoles;

			console.log('checking permissions');

			if (routeRoles.includes(ANY_ROLE)) {
				console.log('ANY ROLE');
				return true;
			} else if (!Permissions.compareRoles(routeRoles, Auth.getDecodedToken().scope)) {
				console.log('has no permissions');
				return false;
			}
		}
	}

	return true;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js